export const services = [
  {
    id: 1,
    icon: "ri-moon-line",
    title: "Lectura de Tarot Completa",
    description: "Una sesión profunda de 60 minutos donde exploramos todas las áreas de tu vida: amor, trabajo, salud y espiritualidad. Recibirás orientación clara y detallada.",
    price: "€65",
    duration: "60 min",
  },
  {
    id: 2,
    icon: "ri-eye-line",
    title: "Videncia Personal",
    description: "Conexión directa con tu energía para revelar mensajes del universo. Ideal para situaciones urgentes o decisiones importantes que requieren claridad inmediata.",
    price: "€45",
    duration: "30 min",
  },
  {
    id: 3,
    icon: "ri-heart-line",
    title: "Tarot del Amor",
    description: "Especializado en relaciones sentimentales. Descubre el estado de tu relación actual, posibles futuros y cómo mejorar tu vida amorosa con guía espiritual.",
    price: "€50",
    duration: "45 min",
  },
  {
    id: 4,
    icon: "ri-star-line",
    title: "Carta Astral + Tarot",
    description: "Combinación poderosa de tu carta natal con una lectura de tarot personalizada. Comprende tu misión de vida, talentos ocultos y los ciclos que te afectan.",
    price: "€85",
    duration: "75 min",
  },
  {
    id: 5,
    icon: "ri-compass-3-line",
    title: "Orientación Laboral",
    description: "Enfocado en tu carrera profesional y proyectos. Descubre oportunidades, obstáculos y el mejor camino para alcanzar el éxito en tu vida laboral.",
    price: "€50",
    duration: "45 min",
  },
  {
    id: 6,
    icon: "ri-sparkling-line",
    title: "Limpieza Energética",
    description: "Sesión de limpieza y protección energética a distancia. Elimina bloqueos, energías negativas y abre caminos para atraer abundancia y bienestar.",
    price: "€40",
    duration: "30 min",
  },
];

export const testimonials = [
  {
    id: 1,
    name: "María González",
    location: "Madrid, España",
    text: "Albert cambió mi vida. Su lectura fue tan precisa que me quedé sin palabras. Me habló de situaciones que nadie podía saber y me dio la claridad que tanto necesitaba para tomar una decisión importante en mi trabajo. Totalmente recomendado.",
    stars: 5,
    avatar: "https://public.readdy.ai/ai/img_res/54cbc7b0b3332b9c1223608f8cb5b761.jpg",
  },
  {
    id: 2,
    name: "Carlos Ruiz",
    location: "Barcelona, España",
    text: "Nunca había creído en el tarot, pero un amigo me recomendó a Albert y decidí probar. La sesión fue increíble, muy profesional y respetuosa. Sus predicciones sobre mi relación se cumplieron al pie de la letra. Ahora soy un fiel seguidor.",
    stars: 5,
    avatar: "https://readdy.ai/api/search-image?query=professional%20man%20portrait%20smiling%20confident%20natural%20light%20soft%20background%20friendly%20appearance&width=100&height=100&seq=t2&orientation=squarish",
  },
  {
    id: 3,
    name: "Laura Martínez",
    location: "Valencia, España",
    text: "La lectura de tarot del amor que hice con Albert fue reveladora. Me explicó con detalle la situación de mi pareja y lo que vendría. Todo lo que me dijo se fue cumpliendo. Es un profesional excepcional con un don especial.",
    stars: 5,
    avatar: "https://readdy.ai/api/search-image?query=young%20woman%20portrait%20smiling%20happy%20natural%20light%20soft%20background%20cheerful%20appearance&width=100&height=100&seq=t3&orientation=squarish",
  },
  {
    id: 4,
    name: "Ana Fernández",
    location: "Sevilla, España",
    text: "Llevo años consultando con Albert y siempre me sorprende su precisión. La limpieza energética que hice fue transformadora, sentí un cambio inmediato en mi vida. Es mi guía espiritual de confianza.",
    stars: 5,
    avatar: "https://readdy.ai/api/search-image?query=mature%20woman%20portrait%20smiling%20wise%20natural%20light%20soft%20background%20serene%20appearance&width=100&height=100&seq=t4&orientation=squarish",
  },
];

export const blogPosts = [
  {
    id: 1,
    category: "Tarot",
    title: "Los Arcanos Mayores: Guía Completa para Principiantes",
    excerpt: "Descubre el significado profundo de cada uno de los 22 arcanos mayores del tarot y cómo pueden guiar tu vida cotidiana.",
    date: "10 Abr 2026",
    readTime: "8 min",
    image: "https://readdy.ai/api/search-image?query=tarot%20cards%20spread%20on%20dark%20velvet%20mystical%20golden%20light%20arcana%20symbols%20ancient%20deck%20beautiful%20artistic%20photography&width=400&height=280&seq=b1&orientation=landscape",
  },
  {
    id: 2,
    category: "Videncia",
    title: "¿Qué es la Videncia y Cómo Puede Ayudarte?",
    excerpt: "Exploramos el mundo de la videncia, sus diferentes modalidades y cómo una consulta puede darte claridad en momentos de incertidumbre.",
    date: "5 Abr 2026",
    readTime: "6 min",
    image: "https://readdy.ai/api/search-image?query=crystal%20ball%20glowing%20mystical%20purple%20light%20spiritual%20energy%20psychic%20vision%20beautiful%20artistic%20photography%20dark%20background&width=400&height=280&seq=b2&orientation=landscape",
  },
  {
    id: 3,
    category: "Espiritualidad",
    title: "Cómo Limpiar tu Energía en Casa: Rituales Efectivos",
    excerpt: "Aprende técnicas sencillas y poderosas para limpiar la energía de tu hogar y crear un ambiente de paz y armonía.",
    date: "28 Mar 2026",
    readTime: "5 min",
    image: "https://readdy.ai/api/search-image?query=sage%20smudging%20ritual%20spiritual%20cleansing%20candles%20crystals%20incense%20smoke%20mystical%20home%20altar%20beautiful%20photography&width=400&height=280&seq=b3&orientation=landscape",
  },
  {
    id: 4,
    category: "Astrología",
    title: "Mercurio Retrógrado: Cómo Navegar Esta Energía",
    excerpt: "Todo lo que necesitas saber sobre Mercurio retrógrado, sus efectos en tu vida y cómo aprovechar este período para tu crecimiento.",
    date: "20 Mar 2026",
    readTime: "7 min",
    image: "https://readdy.ai/api/search-image?query=mercury%20planet%20retrograde%20astrology%20stars%20cosmos%20night%20sky%20mystical%20purple%20golden%20light%20beautiful%20artistic%20photography&width=400&height=280&seq=b4&orientation=landscape",
  },
];
